(function() {
    'use strict';

    var trust = function($sce) {
        return function (value) {
            return value ? $sce.trustAsHtml(value) :  value;
        }
    };

    trust.$inject = ['$sce'];
    angular.module('app').filter('trust', trust);

}());